<template>
  <div class="col-md-12">
    <form
      name="newDocument"
      class="form-horizontal form-label-left"
      @submit.prevent="handleSubmit()"
    >
      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Name :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            name="Name"
            v-validate="'required|max:120'"
            v-model="encodingData.Name"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('Name') }"
          />
        </div>
        <div v-if="submitted && errors.has('Name')" class="invalid-feedback">
          {{ errors.first("Name") }}
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Country:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="SourceId"
            v-model="encodingData.Country"
            class="form-control"
          >
            <option value>Select Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >
              {{ option.countryName }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
          <label class="col-form-label col-md-3 col-sm-3 label-align">OtherName :</label>
          <div class="col-md-6 col-sm-6">
              <input name="OtherName"
                     v-validate="'max:120'"
                     v-model="encodingData.OtherName"
                     class="form-control"
                     :class="{ 'is-invalid': submitted && errors.has('OtherName') }" />
          </div>
          <div v-if="submitted && errors.has('OtherName')" class="invalid-feedback">
              {{ errors.first("OtherName") }}
          </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >State:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="SourceId"
            v-model="encodingData.State"
            class="form-control"
          >
            <option value>Select State</option>
            <option
              v-for="option in provinces"
              v-bind:value="option.province"
              v-bind:key="option.province"
            >
              {{ option.province }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Type:</label
        >
        <div class="col-md-6 col-sm-6">
          <select
            name="SourceId"
            v-model="encodingData.Type"
            class="form-control"
          >
            <option value>Select Type</option>
            <option
              v-for="option in types"
              v-bind:value="option.organizationType"
              v-bind:key="option.organizationType"
            >
              {{ option.organizationType }}
            </option>
          </select>
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >City :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            name="City"
            v-model="encodingData.City"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Address :</label
        >
        <div class="col-md-6 col-sm-6">
          <input
            type="text"
            name="Address"
            v-model="encodingData.Address"
            class="form-control"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Comments :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            class="form-control"
            cols="5"
            rows="5"
          />
        </div>
      </div>

      <div class="item form-group">
        <label class="col-form-label col-md-3 col-sm-3 label-align"
          >Illegal Activities :</label
        >
        <div class="col-md-6 col-sm-6">
          <textarea
            name="IllegalActivities"
            v-model="encodingData.IllegalActivities"
            class="form-control"
            cols="5"
            rows="5"
          />
        </div>
      </div>

      <div class="ln_solid"></div>
      <div class="item form-group">
          <div class="col-md-6 col-sm-6">
              <button type="submit" class="btn btn-primary">Save</button>&nbsp;
              <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
          </div>
      </div>
    </form>
    <b-modal id="LinkPopOG" title="Link Builder" scrollable hide-footer>
      <LinkPopUp />
    </b-modal>
  </div>
</template>
<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstorageOrgType,
  checkLinkMode,
  setObject2Link,
} from "../../helper";
import LinkPopUp from "../master/Linking";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        Name: "",
        OtherName: "",
        Type: "",
        Comments: "",
        Country: "",
        State: "",
        City: "",
        Address: "",
        IllegalActivities: "",
      },
      countries: [],
      provinces: [],
      types: [],
      submitted: false,
    };
  },
  components: {
    LinkPopUp,
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          instance
            .post(EncodeURL + "neworg", this.encodingData, {
              headers: authHeader(),
            })
            .then((response) => {
              if (response.data.error) {
                loader.hide();
                notifyHelper(
                  "error",
                  "there was an error processing your request please try again later"
                );
              } else {
                loader.hide();
                notifyHelper("success", "Saved!");
                //this.clearControls()
                if (checkLinkMode()) {
                  if (confirm("Link this newly created entity?")) {
                    setObject2Link(response.data.id, "OG");
                    this.setLink(response.data.id);
                  }
                }
              }
            })
            .catch(function (error) {
              loader.hide();
              responseCheck(error.response.status);
            });
        }
      });
    },
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.provinces = getlocalstorageProvince();
      this.types = getlocalstorageOrgType();
    },
    setLink: function (id) {
      setObject2Link(id, "OG");
      this.$bvModal.show("LinkPopOG");
    },
    clearControls() {
      
      this.encodingData.Name = "";
      this.encodingData.OtherName = "";
      this.encodingData.Type = "";
      this.encodingData.Comments = "";
      this.encodingData.Country = "";
      this.encodingData.State = "";
      this.encodingData.City = "";
      this.encodingData.Address = "";
      this.encodingData.illegalActivities = "";
    },
  },
  created: function () {
    this.getlibs();
  },
};
</script>
